// src/pages/documents/InternshipLetterDialog.jsx
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
} from "@mui/material";

const InternshipLetterDialog = ({ open, onClose, employee, onSubmit }) => {
  const [formData, setFormData] = useState({
    joining_date: "",
    ending_date: "",
    employment_type: "",
    designation: "",
    shift_time: "",
    working_days: "",
    stipend: "",
    supervisor_name: "",          // ✅ NEW
    supervisor_designation: "",   // ✅ NEW
  });

  const handleChange = (field) => (e) =>
    setFormData({ ...formData, [field]: e.target.value });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Internship Letter Details</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {/* existing fields ... */}
          <Grid item xs={6}>
            <TextField
              label="Joining Date (e.g. 01-MAY-2025)"
              fullWidth
              value={formData.joining_date}
              onChange={handleChange("joining_date")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Ending Date (e.g. 31-JULY-2025)"
              fullWidth
              value={formData.ending_date}
              onChange={handleChange("ending_date")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Employment Type"
              fullWidth
              value={formData.employment_type}
              onChange={handleChange("employment_type")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Designation"
              fullWidth
              value={formData.designation}
              onChange={handleChange("designation")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Shift Time (e.g. 9AM to 6PM)"
              fullWidth
              value={formData.shift_time}
              onChange={handleChange("shift_time")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Working Days (e.g. Monday to Friday)"
              fullWidth
              value={formData.working_days}
              onChange={handleChange("working_days")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Stipend"
              fullWidth
              value={formData.stipend}
              onChange={handleChange("stipend")}
            />
          </Grid>

          {/* ✅ NEW FIELDS */}
          <Grid item xs={6}>
            <TextField
              label="Supervisor Name"
              fullWidth
              value={formData.supervisor_name}
              onChange={handleChange("supervisor_name")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Supervisor Designation"
              fullWidth
              value={formData.supervisor_designation}
              onChange={handleChange("supervisor_designation")}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => onSubmit(employee, formData)}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InternshipLetterDialog;
